import React, { useState, useEffect } from "react";
import TaskHeader from "./TaskHeader";
import TaskHeaderSmall from "./TaskHeaderSmall";
import { toPX } from "../../../client20/logic/WidgetUtils";
import { loadTaskPosition, saveTaskPosition } from "./taskpositions.js";

//Externals
import Draggable from 'react-draggable';
import { Resizable } from "re-resizable";
import "./react-resizable-hack.css"   //this is a css hack for <Resizable>

function Task(props) {

  const { viewportOrder, title, viewport, isEnabled, isMovingAllowed, isResizeAllowed, showNoControls, toggleShowSettings, closeViewport } = props;
  const [draggable, setDraggable] = useState(false);
  const [maximized, setMaximized] = useState(false);
  const [preferenceViewportSize, setPreferenceViewportSize] = useState(null);
  const [preferenceViewportPosition, setPreferenceViewportPosition] = useState(null);

  useEffect(() => {
    if (viewport) {
      loadPosition();
    }

  }, [viewport.viewportId]);

  const loadPosition = () => {
    let taskPosition = loadTaskPosition(viewport.viewportId);
    if (taskPosition) {
      if (taskPosition.width && taskPosition.height) {
        setPreferenceViewportSize({ width: taskPosition.width, height: taskPosition.height });
      }
      if (taskPosition.x && taskPosition.y) {
        setPreferenceViewportPosition({x: taskPosition.x, y: taskPosition.y});
      }
      if (taskPosition.max) {
        setMaximized(taskPosition.max);
      }
    }
  };

  const savePosition = (positionParts) => {
    console.log("SAVING TaskPosition (parts) for Viewport" + viewport.viewportId, positionParts);
    saveTaskPosition(viewport.viewportId, {
      width: positionParts.width ? positionParts.width : preferenceViewportSize ? preferenceViewportSize.width : null,
      height: positionParts.height ? positionParts.height : preferenceViewportSize ? preferenceViewportSize.height : null,
      x: positionParts.x ? positionParts.x : preferenceViewportPosition ? preferenceViewportPosition.x : null,
      y: positionParts.y ? positionParts.y : preferenceViewportPosition ? preferenceViewportPosition.y : null,
      max: positionParts.max ? positionParts.max : maximized ? maximized : null
    })
  };

  const handleEnableDragging = () => {
    console.log("Enable Dragging");
    setDraggable(true);
  };

  const handleDisableDragging = () => {
    console.log("Disable Dragging");
    setDraggable(false);
  };

  const draggingEnabled = () => {
    if (isMovingAllowed === false) return false;
    return !draggable;
  };

  const draggingBounds = () => {
    //is relative to initial position (in px)
    return {
      top: toPX(-(calcTopMargin(1, 0.5))),
      left: toPX(-(calcLeftMargin())),
    };
  };

  const maximizedMargin = 0;
  const headerHeightBig = 2;        //taken from viewportHeader
  const headerHeightSmall = 1.5;      //taken from viewportHeaderSmall

  const calcTopMargin = (baseMargin, headerMargin) => {
    if (viewportOrder === 0)
      return baseMargin;
    if (viewportOrder === 1)
      return baseMargin + headerHeightBig + headerMargin;
    return (baseMargin + headerHeightBig + headerMargin) + ((viewportOrder - 1) * (headerHeightSmall + headerMargin));
  };

  const calcLeftMargin = () => {
    return (viewportOrder + 1);
  };

  const rootStyle = {
    display: "inline-block",
    overflow: "auto",         //for some strange reason it is good to set this if inside <Draggable>
    position: "absolute",
    borderStyle: "solid",
    zIndex: (viewportOrder + 1) * 100,
    borderWidth: viewportOrder > 0 ? "2px" : "3px"
  };

  const paperStyleNormal = {
    top: calcTopMargin(1, 0.5) + "em",
    left: calcLeftMargin() + "em",
  };

  const paperStyleMax = {
    top: maximizedMargin + "em",
    left: maximizedMargin + "em",
    right: maximizedMargin + "em",
    bottom: maximizedMargin + "em",
  };

  const maximizedContainerStyle = {
    width: "100%",
    height: "calc(100% - " + (viewportOrder > 0 ? headerHeightSmall : headerHeightBig) + "em)"
  };

  const resizeableSize = () => ({
    width: preferenceViewportSize ? preferenceViewportSize.width : toPX(viewport.width) + "px",
    height: preferenceViewportSize ? preferenceViewportSize.height : toPX(viewport.height) + "px",
  });

  const draggingPosition = () => ({
    x: preferenceViewportPosition ? preferenceViewportPosition.x : 0,
    y: preferenceViewportPosition ? preferenceViewportPosition.y : 0,
  });

  const resizableEnabled = () => {
    if (isResizeAllowed === false) return false;
    return {
      right: true,
      bottom: true,
      bottomRight: true,
    }
  };

  const handleCloseTask = () => {
    handleDisableDragging();
    closeViewport(viewport.viewportId);
  };

  // const handleMinimizeTask = () => {
  //   handleDisableDragging();
  //   navigatAfterCloseSession(props.history, session);
  // };

  const handleMaximizeTask = () => {
    handleDisableDragging();
    onTaskMaximized();
  };

  const handleRestoreTask = () => {
    handleDisableDragging();
    onTaskRestored();
  };

  const onTaskMaximized = () => {
    console.log("taskMaximized", viewport.viewportId);
    setMaximized(true);
    savePosition({max: true});
  };

  const onTaskRestored = () => {
    console.log("taskRestored", viewport.viewportId);
    setMaximized(false);
    savePosition({max: false});
  };

  const onTaskResized = (deltaWidth, deltaHeight, newWidth, newHeight) => {
    console.log("taskResized", viewport.viewportId, deltaWidth, deltaHeight, newWidth, newHeight);
    var news = { width: newWidth, height: newHeight };
    setPreferenceViewportSize(news);
    savePosition(news);
  };

  const onTaskMoved = (newX, newY) => {
    console.log("taskMoved", viewport.viewportId, newX, newY);
    var news = {x: newX, y: newY};
    setPreferenceViewportPosition(news)
    savePosition(news);
  };

  const renderHeader = (min, max, close, isMovable) => {
    if (viewportOrder > 0)
      return (
        <TaskHeaderSmall
          title={title}
          isEnabled={isEnabled}
          closeTask={handleCloseTask}
          enableDragging={handleEnableDragging}
          disableDragging={handleDisableDragging}
          showNoControls={showNoControls}

          isMoveable={isMovable}
        />
      );
    else
      return (
        <TaskHeader
          title={title}
          isEnabled={isEnabled}
          enableDragging={handleEnableDragging}
          disableDragging={handleDisableDragging}
          showNoControls={showNoControls}

          isMoveable={isMovable && !maximized}
          isMaximized={maximized}
          showMaximize={max}
          showClose={close}

          toggleShowSettings={toggleShowSettings}
          closeTask={handleCloseTask}
          maximizeTask={handleMaximizeTask}
          restoreTask={handleRestoreTask}
        />
      );
  }

  const renderMaximizedTask = () => {
    return (
      <div className={'dx-theme-accent-as-border-color'} style={{ ...rootStyle, ...paperStyleMax }}>
        {renderHeader(true, true, true, true)}
        <div style={maximizedContainerStyle}>
          {props.children}
        </div>
      </div>
    )
  };

  const renderTask = () => {
    return (
      <Draggable disabled={draggingEnabled()} bounds={draggingBounds()} position={draggingPosition()} onStop={(e, data) => onTaskMoved(data.lastX, data.lastY)}>
        <div className={'dx-theme-accent-as-border-color'} style={{ ...rootStyle, ...paperStyleNormal }}>
          {renderHeader(true, true, true, true)}
          <Resizable
            size={resizeableSize()}
            style={{ overflow: "hidden" }}
            enable={resizableEnabled()}
            onResizeStop={(e, direction, ref, d) => onTaskResized(d.width, d.height, ref.style.width, ref.style.height)}
          >
            {props.children}
          </Resizable>
        </div>
      </Draggable>
    );
  };

  return (
    maximized
      ? renderMaximizedTask()
      : renderTask()
  );
}

export default Task;
